var map = {
	"./avatars/avatar-aaron-powell/avatar-aaron-powell.webp": 77219,
	"./avatars/avatar-alex-allan/avatar-alex-allan.webp": 51118,
	"./avatars/avatar-alex-allan2/avatar-alex-allan2.webp": 90196,
	"./avatars/avatar-andy-gray/avatar-andy-gray.webp": 35443,
	"./avatars/avatar-andy-gray2/avatar-andy-gray2.webp": 60179,
	"./avatars/avatar-andy-gray3/avatar-andy-gray3.webp": 29551,
	"./avatars/avatar-barbara-johnson/avatar-barbara-johnson.webp": 91174,
	"./avatars/avatar-barbara-johnson2/avatar-barbara-johnson2.webp": 16249,
	"./avatars/avatar-gartner/avatar-gartner.webp": 11597,
	"./avatars/avatar-howard-cooke/avatar-howard-cooke.webp": 52799,
	"./avatars/avatar-jaclyn-de-jesus/avatar-jaclyn-de-jesus.webp": 51167,
	"./avatars/avatar-kortical-team/avatar-kortical-team.webp": 74307,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1--mobile.webp": 15925,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1.webp": 53759,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2--mobile.webp": 22650,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2.webp": 88094,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3--mobile.webp": 9506,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3.webp": 10274,
	"./avatars/avatar-matt-hancock/avatar-matt-hancock.webp": 59915,
	"./avatars/avatar-simon-james/avatar-simon-james.webp": 56883,
	"./clients/nhs-logo/nhs-logo.webp": 91791,
	"./competitors/aws-logo/aws-logo.webp": 93470,
	"./competitors/dataRobot-logo/dataRobot-logo.webp": 95420,
	"./competitors/google-logo/google-logo.webp": 33849,
	"./competitors/h2o-logo/h2o-logo.webp": 6039,
	"./competitors/microsoft-logo/microsoft-logo.webp": 89803,
	"./competitors/schroders-logo/schroders-logo.webp": 84112,
	"./content/about-us-hero/about-us-hero--mobile.webp": 44901,
	"./content/about-us-hero/about-us-hero.webp": 73058,
	"./content/about-us-security/about-us-security--mobile.webp": 65460,
	"./content/about-us-security/about-us-security.webp": 17118,
	"./content/about-us-security1/about-us-security1--mobile.webp": 16898,
	"./content/about-us-security1/about-us-security1.webp": 68136,
	"./content/about-us-sustainability/about-us-sustainability--mobile.webp": 64411,
	"./content/about-us-sustainability/about-us-sustainability.webp": 97628,
	"./content/ai-consultancy-1/ai-consultancy-1--mobile.webp": 49902,
	"./content/ai-consultancy-1/ai-consultancy-1.webp": 64542,
	"./content/ai-consultancy-2/ai-consultancy-2.webp": 59233,
	"./content/ai-marketing-1/ai-marketing-1--mobile.webp": 31935,
	"./content/ai-marketing-1/ai-marketing-1.webp": 77110,
	"./content/ai-marketing-3/ai-marketing-3--mobile.webp": 29811,
	"./content/ai-marketing-3/ai-marketing-3.webp": 6327,
	"./content/ai-marketing-4/ai-marketing-4--mobile.webp": 19556,
	"./content/ai-marketing-4/ai-marketing-4.webp": 69112,
	"./content/ai-marketing-5/ai-marketing-5--mobile.webp": 22357,
	"./content/ai-marketing-5/ai-marketing-5.webp": 60147,
	"./content/ai-marketing-6/ai-marketing-6--mobile.webp": 92310,
	"./content/ai-marketing-6/ai-marketing-6.webp": 15614,
	"./content/ai-marketing-7/ai-marketing-7--mobile.webp": 60099,
	"./content/ai-marketing-7/ai-marketing-7.webp": 32213,
	"./content/ai-marketing-8/ai-marketing-8--mobile.webp": 36528,
	"./content/ai-marketing-8/ai-marketing-8.webp": 73158,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1--mobile.webp": 39329,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1.webp": 75416,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2--mobile.webp": 91443,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2.webp": 27712,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3--mobile.webp": 69503,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3.webp": 923,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4--mobile.webp": 76614,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4.webp": 70918,
	"./content/ai-solutions-with-roadmap5/ai-solutions-with-roadmap5.webp": 35653,
	"./content/app-features-1/app-features-1--mobile.webp": 27050,
	"./content/app-features-1/app-features-1.webp": 73146,
	"./content/app-features-2/app-features-2--mobile.webp": 68812,
	"./content/app-features-2/app-features-2.webp": 39765,
	"./content/app-features-3/app-features-3--mobile.webp": 44683,
	"./content/app-features-3/app-features-3.webp": 11259,
	"./content/app-features-4/app-features-4--mobile.webp": 898,
	"./content/app-features-4/app-features-4.webp": 34515,
	"./content/app-features-5/app-features-5--mobile.webp": 48146,
	"./content/app-features-5/app-features-5.webp": 53513,
	"./content/app-features-6/app-features-6--mobile.webp": 93395,
	"./content/app-features-6/app-features-6.webp": 86031,
	"./content/art-innovation/art-innovation--mobile.webp": 97283,
	"./content/art-innovation/art-innovation.webp": 67251,
	"./content/avatar-andy-gray3/avatar-andy-gray3.webp": 24366,
	"./content/bg-abandoned-robot/bg-abandoned-robot--mobile.webp": 79111,
	"./content/bg-abandoned-robot/bg-abandoned-robot.webp": 48051,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service--mobile.webp": 52422,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service.webp": 8305,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap--mobile.webp": 45990,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap.webp": 31856,
	"./content/bg-api/bg-api.webp": 96901,
	"./content/bg-app/bg-app--mobile.webp": 56243,
	"./content/bg-app/bg-app.webp": 3451,
	"./content/bg-blood/bg-blood--mobile.webp": 86133,
	"./content/bg-blood/bg-blood.webp": 22499,
	"./content/bg-boxes/bg-boxes--mobile.webp": 83468,
	"./content/bg-boxes/bg-boxes.webp": 38824,
	"./content/bg-business-dilemma/bg-business-dilemma.webp": 43847,
	"./content/bg-clocks/bg-clocks--mobile.webp": 71155,
	"./content/bg-clocks/bg-clocks.webp": 21757,
	"./content/bg-credit-score/bg-credit-score--mobile.webp": 51585,
	"./content/bg-credit-score/bg-credit-score.webp": 91193,
	"./content/bg-cs-zappi/bg-cs-zappi--mobile.webp": 99290,
	"./content/bg-cs-zappi/bg-cs-zappi.webp": 55457,
	"./content/bg-doctor/bg-doctor--mobile.webp": 94702,
	"./content/bg-doctor/bg-doctor.webp": 31601,
	"./content/bg-email-automation/bg-email-automation--mobile.webp": 74269,
	"./content/bg-email-automation/bg-email-automation.webp": 3397,
	"./content/bg-finance/bg-finance--mobile.webp": 96126,
	"./content/bg-finance/bg-finance.webp": 82405,
	"./content/bg-flydocs/bg-flydocs.webp": 97429,
	"./content/bg-ford/bg-ford--mobile.webp": 61591,
	"./content/bg-ford/bg-ford.webp": 86909,
	"./content/bg-hcuk/bg-hcuk.webp": 6122,
	"./content/bg-innovation/bg-innovation--mobile.webp": 17374,
	"./content/bg-innovation/bg-innovation.webp": 91659,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing--mobile.webp": 68157,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing.webp": 72827,
	"./content/bg-notes/bg-notes--mobile.webp": 63607,
	"./content/bg-notes/bg-notes.webp": 10706,
	"./content/bg-numbers/bg-numbers--mobile.webp": 87627,
	"./content/bg-numbers/bg-numbers.webp": 10360,
	"./content/bg-pandas-profiling/bg-pandas-profiling--mobile.webp": 43301,
	"./content/bg-pandas-profiling/bg-pandas-profiling.webp": 37897,
	"./content/bg-schroders/bg-schroders.webp": 25107,
	"./content/bg-spacex/bg-spacex--mobile.webp": 53448,
	"./content/bg-spacex/bg-spacex.webp": 28778,
	"./content/bg-superhuman-ai/bg-superhuman-ai--mobile.webp": 91002,
	"./content/bg-superhuman-ai/bg-superhuman-ai.webp": 32669,
	"./content/bg-tac/bg-tac--mobile.webp": 13696,
	"./content/bg-tac/bg-tac.webp": 82194,
	"./content/bg-tax/bg-tax--mobile.webp": 73896,
	"./content/bg-tax/bg-tax.webp": 95740,
	"./content/bg-tech-nation-2/bg-tech-nation-2--mobile.webp": 59867,
	"./content/bg-tech-nation-2/bg-tech-nation-2.webp": 2608,
	"./content/bg-tech-nation/bg-tech-nation--mobile.webp": 51127,
	"./content/bg-tech-nation/bg-tech-nation.webp": 41343,
	"./content/bg-tower/bg-tower--mobile.webp": 71724,
	"./content/bg-tower/bg-tower.webp": 29766,
	"./content/bg-what-is-ml/bg-what-is-ml--mobile.webp": 273,
	"./content/bg-what-is-ml/bg-what-is-ml.webp": 4836,
	"./content/bg-wires/bg-wires--mobile.webp": 27305,
	"./content/bg-wires/bg-wires.webp": 9620,
	"./content/bg-zappi/bg-zappi--mobile.webp": 3560,
	"./content/bg-zappi/bg-zappi.webp": 36841,
	"./content/career-perks-1/career-perks-1.webp": 35271,
	"./content/career-perks-2/career-perks-2.webp": 34255,
	"./content/career-perks-3/career-perks-3.webp": 30505,
	"./content/career-perks-4/career-perks-4.webp": 44024,
	"./content/chess/chess--mobile.webp": 61887,
	"./content/chess/chess.webp": 17653,
	"./content/client-video-embed-placeholder/client-video-embed-placeholder.webp": 721,
	"./content/comparisons-app-creation/comparisons-app-creation--mobile.webp": 87317,
	"./content/comparisons-app-creation/comparisons-app-creation.webp": 52568,
	"./content/comparisons-automl-results/comparisons-automl-results.webp": 51318,
	"./content/comparisons-breadth-features/comparisons-breadth-features.webp": 76718,
	"./content/comparisons-control-transparency/comparisons-control-transparency.webp": 9169,
	"./content/comparisons-eda/comparisons-eda.webp": 85233,
	"./content/comparisons-feature-engineering/comparisons-feature-engineering.webp": 77214,
	"./content/comparisons-mission-critical/comparisons-mission-critical.webp": 15195,
	"./content/comparisons-model-explain/comparisons-model-explain.webp": 27668,
	"./content/comparisons-team/comparisons-team--mobile.webp": 59792,
	"./content/comparisons-team/comparisons-team.webp": 56823,
	"./content/cs-deloitte/cs-deloitte--mobile.webp": 23033,
	"./content/cs-deloitte/cs-deloitte.webp": 78877,
	"./content/cs-email-automation/cs-email-automation--mobile.webp": 62549,
	"./content/cs-email-automation/cs-email-automation.webp": 66159,
	"./content/cs-solution-architecture/cs-solution-architecture--mobile.webp": 29520,
	"./content/cs-solution-architecture/cs-solution-architecture.webp": 78565,
	"./content/data-about-screenshot-1/data-about-screenshot-1--mobile.webp": 52814,
	"./content/data-about-screenshot-1/data-about-screenshot-1.webp": 31020,
	"./content/data-about-screenshot-2/data-about-screenshot-2--mobile.webp": 37005,
	"./content/data-about-screenshot-2/data-about-screenshot-2.webp": 55362,
	"./content/data-about-screenshot-3/data-about-screenshot-3--mobile.webp": 22856,
	"./content/data-about-screenshot-3/data-about-screenshot-3.webp": 31480,
	"./content/data-free-for-beta-mobile/data-free-for-beta-mobile.webp": 82859,
	"./content/data-free-for-beta/data-free-for-beta.webp": 87464,
	"./content/data-more-about-img/data-more-about-img--mobile.webp": 76401,
	"./content/data-more-about-img/data-more-about-img.webp": 14349,
	"./content/data-more-about-img2/data-more-about-img2--mobile.webp": 4263,
	"./content/data-more-about-img2/data-more-about-img2.webp": 12315,
	"./content/data-more-about-img3/data-more-about-img3--mobile.webp": 59703,
	"./content/data-more-about-img3/data-more-about-img3.webp": 89038,
	"./content/data-quote-simon-james/data-quote-simon-james--mobile.webp": 67292,
	"./content/data-quote-simon-james/data-quote-simon-james.webp": 93850,
	"./content/feature-importances-long/feature-importances-long--mobile.webp": 95643,
	"./content/feature-importances-long/feature-importances-long.webp": 23806,
	"./content/feature-importances-sales/feature-importances-sales--mobile.webp": 52147,
	"./content/feature-importances-sales/feature-importances-sales.webp": 75533,
	"./content/feature-importances/feature-importances--mobile.webp": 5067,
	"./content/feature-importances/feature-importances.webp": 87726,
	"./content/form-thank-you-smiley/form-thank-you-smiley--mobile.webp": 73159,
	"./content/form-thank-you-smiley/form-thank-you-smiley.webp": 86992,
	"./content/gs-1-upload/gs-1-upload--mobile.webp": 38934,
	"./content/gs-1-upload/gs-1-upload.webp": 32317,
	"./content/gs-2-target/gs-2-target--mobile.webp": 88173,
	"./content/gs-2-target/gs-2-target.webp": 23396,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode--mobile.webp": 70152,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode.webp": 23904,
	"./content/gs-3-publishmodel/gs-3-publishmodel--mobile.webp": 87529,
	"./content/gs-3-publishmodel/gs-3-publishmodel.webp": 72138,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit--mobile.webp": 80361,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit.webp": 6128,
	"./content/gs-5-businessvalue/gs-5-businessvalue--mobile.webp": 62891,
	"./content/gs-5-businessvalue/gs-5-businessvalue.webp": 75760,
	"./content/gs-6-explainmodel/gs-6-explainmodel--mobile.webp": 31109,
	"./content/gs-6-explainmodel/gs-6-explainmodel.webp": 59237,
	"./content/gs-8-deploymodel/gs-8-deploymodel--mobile.webp": 56716,
	"./content/gs-8-deploymodel/gs-8-deploymodel.webp": 52014,
	"./content/gs-R-code/gs-R-code--mobile.webp": 58226,
	"./content/gs-R-code/gs-R-code.webp": 88862,
	"./content/gs-python-code/gs-python-code--mobile.webp": 42883,
	"./content/gs-python-code/gs-python-code.webp": 88429,
	"./content/icon-andy-signature/icon-andy-signature--mobile.webp": 13927,
	"./content/icon-andy-signature/icon-andy-signature.webp": 78144,
	"./content/img-app-deployment/img-app-deployment--mobile.webp": 63492,
	"./content/img-app-deployment/img-app-deployment.webp": 15018,
	"./content/img-app-explain/img-app-explain--mobile.webp": 37080,
	"./content/img-app-explain/img-app-explain.webp": 78966,
	"./content/img-app-graphs/img-app-graphs--mobile.webp": 84564,
	"./content/img-app-graphs/img-app-graphs.webp": 75455,
	"./content/img-app-leaderboard/img-app-leaderboard--mobile.webp": 94839,
	"./content/img-app-leaderboard/img-app-leaderboard.webp": 44021,
	"./content/img-app-pension/img-app-pension--mobile.webp": 40904,
	"./content/img-app-pension/img-app-pension.webp": 14335,
	"./content/img-app-training/img-app-training--mobile.webp": 14031,
	"./content/img-app-training/img-app-training.webp": 41851,
	"./content/img-art-pandas-profiling-1/img-art-pandas-profiling-1.webp": 30453,
	"./content/img-art-pandas-profiling-10/img-art-pandas-profiling-10.webp": 66704,
	"./content/img-art-pandas-profiling-11/img-art-pandas-profiling-11.webp": 43675,
	"./content/img-art-pandas-profiling-2/img-art-pandas-profiling-2.webp": 7551,
	"./content/img-art-pandas-profiling-3/img-art-pandas-profiling-3.webp": 13950,
	"./content/img-art-pandas-profiling-4/img-art-pandas-profiling-4.webp": 16002,
	"./content/img-art-pandas-profiling-5/img-art-pandas-profiling-5.webp": 32062,
	"./content/img-art-pandas-profiling-6/img-art-pandas-profiling-6.webp": 50942,
	"./content/img-art-pandas-profiling-7/img-art-pandas-profiling-7.webp": 69304,
	"./content/img-art-pandas-profiling-8/img-art-pandas-profiling-8.webp": 8696,
	"./content/img-art-pandas-profiling-9/img-art-pandas-profiling-9.webp": 1683,
	"./content/img-asaas/img-asaas--mobile.webp": 43346,
	"./content/img-asaas/img-asaas.webp": 28628,
	"./content/img-credit-score-benefit/img-credit-score-benefit--mobile.webp": 99492,
	"./content/img-credit-score-benefit/img-credit-score-benefit.webp": 36621,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new--mobile.webp": 80661,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new.webp": 52882,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline--mobile.webp": 89839,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline.webp": 62113,
	"./content/img-data-prep-preview/img-data-prep-preview--mobile.webp": 71511,
	"./content/img-data-prep-preview/img-data-prep-preview.webp": 9238,
	"./content/img-kortical-timeline/img-kortical-timeline--mobile.webp": 10323,
	"./content/img-kortical-timeline/img-kortical-timeline.webp": 24461,
	"./content/img-ml-vs-programming/img-ml-vs-programming--mobile.webp": 39135,
	"./content/img-ml-vs-programming/img-ml-vs-programming.webp": 16964,
	"./content/img-nhs-app/img-nhs-app--mobile.webp": 2124,
	"./content/img-nhs-app/img-nhs-app.webp": 59007,
	"./content/img-nhs-kortical/img-nhs-kortical--mobile.webp": 61907,
	"./content/img-nhs-kortical/img-nhs-kortical.webp": 3813,
	"./content/img-nhs-optimiser/img-nhs-optimiser--mobile.webp": 95406,
	"./content/img-nhs-optimiser/img-nhs-optimiser.webp": 55354,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain--mobile.webp": 98698,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain.webp": 119,
	"./content/img-nhs-process/img-nhs-process--mobile.webp": 94174,
	"./content/img-nhs-process/img-nhs-process.webp": 32707,
	"./content/img-platform-explain/img-platform-explain--mobile.webp": 53757,
	"./content/img-platform-explain/img-platform-explain.webp": 63368,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon--mobile.webp": 6397,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon.webp": 68379,
	"./content/img-tac-graph/img-tac-graph--mobile.webp": 43784,
	"./content/img-tac-graph/img-tac-graph.webp": 32849,
	"./content/img-what-is-ml/img-what-is-ml--mobile.webp": 29087,
	"./content/img-what-is-ml/img-what-is-ml.webp": 46641,
	"./content/innovator-1/innovator-1--mobile.webp": 63474,
	"./content/innovator-1/innovator-1.webp": 69746,
	"./content/intelligent-automation-1/intelligent-automation-1--mobile.webp": 41640,
	"./content/intelligent-automation-1/intelligent-automation-1.webp": 98346,
	"./content/intelligent-automation-2/intelligent-automation-2.webp": 48520,
	"./content/inventory-optimisation-1/inventory-optimisation-1--mobile.webp": 53041,
	"./content/inventory-optimisation-1/inventory-optimisation-1.webp": 87342,
	"./content/inventory-optimisation-2/inventory-optimisation-2--mobile.webp": 93528,
	"./content/inventory-optimisation-2/inventory-optimisation-2.webp": 57813,
	"./content/key-brains/key-brain--blue.webp": 29257,
	"./content/key-brains/key-brain--green.webp": 52107,
	"./content/key-brains/key-brain--pink.webp": 80721,
	"./content/key-brains/key-brain--yellow.webp": 95292,
	"./content/lego-unicorn-man/lego-unicorn-man--mobile.webp": 44863,
	"./content/lego-unicorn-man/lego-unicorn-man.webp": 21351,
	"./content/podcasts-hero/podcasts-hero--mobile.webp": 55351,
	"./content/podcasts-hero/podcasts-hero.webp": 36031,
	"./content/predicting-failures/predicting-failures--mobile.webp": 49894,
	"./content/predicting-failures/predicting-failures.webp": 6311,
	"./content/preview-platform/preview-platform.webp": 44630,
	"./content/reed-1/reed-1--mobile.webp": 55571,
	"./content/reed-1/reed-1.webp": 62732,
	"./content/reed-2/reed-2--mobile.webp": 86820,
	"./content/reed-2/reed-2.webp": 35509,
	"./content/reed-3/reed-3--mobile.webp": 2958,
	"./content/reed-3/reed-3.webp": 74672,
	"./content/reed-4/reed-4--mobile.webp": 79607,
	"./content/reed-4/reed-4.webp": 39136,
	"./content/reed-5/reed-5.webp": 67886,
	"./content/screenshot-actions/screenshot-actions--mobile.webp": 2313,
	"./content/screenshot-actions/screenshot-actions.webp": 57862,
	"./content/screenshot-feature-importances/screenshot-feature-importances--mobile.webp": 47441,
	"./content/screenshot-feature-importances/screenshot-feature-importances.webp": 29224,
	"./content/screenshot-target-scores/screenshot-target-scores--mobile.webp": 55263,
	"./content/screenshot-target-scores/screenshot-target-scores.webp": 25802,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart--mobile.webp": 60982,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart.webp": 90637,
	"./content/superhuman-ai-1/superhuman-ai-1.webp": 60460,
	"./content/superhuman-ai/superhuman-ai.webp": 1232,
	"./content/tech-nation-1/tech-nation-1--mobile.webp": 78270,
	"./content/tech-nation-1/tech-nation-1.webp": 70094,
	"./content/tech-nation-2/tech-nation-2.webp": 76870,
	"./content/unicorn-lego-man/unicorn-lego-man--mobile.webp": 45334,
	"./content/unicorn-lego-man/unicorn-lego-man.webp": 84037,
	"./content/video-placeholder/video-placeholder.webp": 24172,
	"./content/why-ml-10/why-ml-10--mobile.webp": 40077,
	"./content/why-ml-10/why-ml-10.webp": 47113,
	"./content/why-ml-3/why-ml-3--mobile.webp": 82767,
	"./content/why-ml-3/why-ml-3.webp": 373,
	"./content/why-ml-9/why-ml-9.webp": 73548,
	"./content/woman-developer-thinking/woman-developer-thinking--mobile.webp": 74066,
	"./content/woman-developer-thinking/woman-developer-thinking.webp": 63735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31612;